export default "__VITE_ASSET__d425d5b0__"